<div class="layout-topbar">
  <div class="topbar-start">
    <button
      #menubutton
      type="button"
      class="topbar-menubutton p-link p-trigger transition-duration-300"
      (click)="onMenuButtonClick()"
      [attr.aria-label]="'TOOLTIP.TOPBAR.MENU' | translate"
    >
      <i class="pi pi-bars" aria-hidden="true"></i>
    </button>
  </div>
  <div class="layout-topbar-menu-section">
    <nav class="layout-topbar-menu" aria-label="Topbar menu">
      <app-sidebar></app-sidebar>
    </nav>
  </div>
  <div class="topbar-end">
    <button 
      type="button"
      class="secondary-logo-button"
      (click)="openGreece20()"
      pTooltip="Ελλάδα 2.0"
      tooltipPosition="bottom"
      [attr.aria-label]="'Ελλάδα 2.0 - Greece 2.0'"
    >
      <img src="./assets/layout/images/ellada20.png" alt="Ellada 2.0 Logo" class="secondary-logo-img" />
    </button>
    <ul class="topbar-menu">
      <!-- <li [class]="layoutService.isHorizontal() ? 'topbar-search hidden' : 'topbar-search hidden sm:block'">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input type="text" pInputText placeholder="Search" class="w-12rem sm:w-full" />
      </span>
    </li> -->
      <!-- <li [class]="layoutService.isHorizontal() ? 'block topbar-item' : 'block sm:hidden topbar-item'">
    <a pStyleClass="@next" enterFromClass="ng-hidden" enterActiveClass="px-scalein" leaveToClass="ng-hidden" leaveActiveClass="px-fadeout" [hideOnOutsideClick]="true" pRipple>
      <i class="pi pi-search"></i>
    </a>
    <ul [class]="'ng-hidden topbar-menu active-topbar-menu p-3 w-15rem  z-5'" style="bottom: -5.8rem">
      <span class="p-input-icon-left w-full">
        <i class="pi pi-search"></i>
        <input type="text" pInputText placeholder="Search" class="w-full" />
      </span>
    </ul>
  </li> -->

      @if(appName &&( appName == 'insured' || appName == 'doctor')){
      <li class="topbar-item">
        <button
          pButton
          type="button"
          (click)="goToInbox()"
          pTooltip="{{ 'TOOLTIP.TOPBAR.INBOX' | translate }}"
          tooltipPosition="bottom"
          [attr.aria-label]="('ACCESSIBILITY.INBOX_LABEL' | translate: { count: messageCount })"
          [style]="{ all: 'unset', cursor: 'pointer' }"
          class="p-button-text p-button-secondary mr-2 flex-shrink-0"
        >
          <i
            pbadge=""
            class="p-element pi pi-inbox p-overlay-badge"
            aria-hidden="true"
            style="font-size: 1.4rem"
          >
            @if(messageCount>0){
            <span
              #notification
              class="p-badge p-component p-badge-no-gutter"
              style="background: var(--primary-color); color: white"
              >{{ messageCount }}</span
            >
            }
          </i>
        </button>
      </li>
      }
      <li class="topbar-item">
        <button
          pButton
          type="button"
          (click)="showSidebar()"
          pTooltip="{{ 'TOOLTIP.TOPBAR.NOTIFICATIONS' | translate }}"
          [attr.aria-label]="'TOOLTIP.TOPBAR.NOTIFICATIONS' | translate"
          tooltipPosition="bottom"
          [style]="{ all: 'unset', cursor: 'pointer' }"
          class="p-button-text p-button-secondary flex-shrink-0"
        >
          <i
            pbadge=""
            class="p-element pi pi-bell p-overlay-badge"
            style="font-size: 1.4rem"
            aria-hidden="true"
          >
            @if(notificationCount>0){
            <span
              #notification
              class="p-badge p-component p-badge-no-gutter"
              style="background: var(--primary-color); color: white"
              >{{ notificationCount }}</span
            >
            }
          </i>
        </button>
      </li>
      <li class="topbar-item">
        <button
          pButton
          type="button"
          [icon]="themeMode"
          class="flex-shrink-0"
          (click)="changeThemeMode()"
          pTooltip="{{ 'TOOLTIP.TOPBAR.CHANGE_THEME' | translate }}"
          [attr.aria-label]="'TOOLTIP.TOPBAR.CHANGE_THEME' | translate"
          tooltipPosition="bottom"
         [text]="true" severity="secondary"></button>
      </li>
      <!-- <button (click)="switchLanguage('en')">English</button>
      <button (click)="switchLanguage('gr')">Ελληνικά</button> -->
      <li class="topbar-item">
        <div>
          <button
            type="button"
            (click)="toggleDropdown()"
            pTooltip="{{ 'TOOLTIP.TOPBAR.SELECT_LANGUAGE' | translate }}"
            tooltipPosition="bottom"
            style="
              border: none;
              background: transparent;
              cursor: pointer;
              padding: 0;
            "
          >
            <img
              [src]="selectedLanguageIcon"
              alt="Selected Language"
              style="width: 20px; height: auto"
            />
          </button>

          @if (dropdownVisible) {
          <nav aria-label="Language selection menu">
          <div class="dropdown-menu" style="position: absolute; z-index: 1000">
            @for (lang of languages; track lang) {
            <button
              type="button"
              (click)="switchLanguage(lang.value)"
              style="
                display: flex;
                align-items: center;
                cursor: pointer;
                padding: 5px;
                background: none;
                border: none;
                width: 100%;
              "
            >
              <img
                [src]="lang.icon"
                alt="{{ lang.label }}"
                style="width: 15px; height: auto; margin-right: 2px"
              />
              {{ lang.label }}
            </button>
            }
          </div>
          </nav>
          }
        </div>
      </li>
      
      <li class="topbar-item">
        <button
          type="button"
          pStyleClass="@next"
          enterFromClass="ng-hidden"
          enterActiveClass="px-scalein"
          leaveToClass="ng-hidden"
          leaveActiveClass="px-fadeout"
          [hideOnOutsideClick]="true"
          pRipple
          class="cursor-pointer p-link"
          style="background: none; border: none; padding: 0;"
          id="profile-menu-btn"
          aria-haspopup="menu"
          aria-controls="profile-menu"
          [attr.aria-expanded]="profileMenuVisible"
          aria-label="Profile menu"
          (click)="toggleProfileMenu()"
        >
          <img
            class="border-round-xl"
            src="assets/demo/images/avatar/circle/avatar-m-2.png"
            alt="Profile"
          />
        </button>
        <ul
          id="profile-menu"
          role="menu"
          aria-labelledby="profile-menu-btn"
          [class]="'topbar-menu active-topbar-menu p-4 w-15rem z-5 ng-hidden'"
        >
          <li role="none" class="m-0 mb-3">
            <button
              type="button"
              role="menuitem"
              class="flex align-items-center hover:text-primary-500 transition-duration-200 cursor-pointer p-link w-full"
              style="background: none; border: none; padding: 0;"
              pStyleClass="@grandparent"
              enterFromClass="ng-hidden"
              enterActiveClass="px-scalein"
              leaveToClass="ng-hidden"
              leaveActiveClass="px-fadeout"
              (click)="goToSettings()"
            >
              <i class="pi pi-fw pi-cog mr-2" aria-hidden="true"></i>
              <span>Settings</span>
            </button>
          </li>
          <li role="none" class="m-0">
            <a
              role="menuitem"
              (click)="logout()"
              href="#"
              class="flex align-items-center hover:text-primary-500 transition-duration-200"
              pStyleClass="@grandparent"
              enterFromClass="ng-hidden"
              enterActiveClass="px-scalein"
              leaveToClass="ng-hidden"
              leaveActiveClass="px-fadeout"
            >
              <i class="pi pi-fw pi-sign-out mr-2" aria-hidden="true"></i>
              <span>Logout</span>
            </a>
          </li>
        </ul>
      </li>
      <!-- <li class="topbar-item">
          <button
            pButton
            type="button"
            icon="pi pi-sign-out"
            class="flex-shrink-0"
            (click)="logout()"
            pTooltip="{{ 'TOOLTIP.TOPBAR.LOGOUT' | translate }}"
            tooltipPosition="bottom"
           [text]="true" severity="secondary"></button>
        </li> -->
    </ul>
  </div>
</div>
<p-toast [life]="3000">
  <ng-template let-msg pTemplate="message">
    <button
      type="button"
      class="custom-toast p-link"
      style="background: none; border: none; text-align: left; width: 100%; cursor: pointer;"
      aria-label="Άνοιγμα ειδοποιήσεων"
      (click)="showSidebar()"
    >
      <div class="custom-header">{{ msg.message }}</div>
      <div class="custom-detail">{{ msg.detail }}</div>
    </button>
  </ng-template></p-toast
>
<p-drawer
  position="right"
  [(visible)]="sidebarVisible"
  (onHide)="onSidebarClose()"
  ariaCloseLabel="Κλείσιμο"
>
  <ng-template pTemplate="content">
    <div class="flex flex-column">
      @if(newNotifications.length > 0){
      <button
        pButton
        (click)="clearAllNotifications()"
        class="bg-gray-700 text-white mb-3"
      >
        Καθαρισμός Όλων
      </button>
      }
      @for(message of newNotifications; track $index){

      <p-message [severity]="$any(message.severity)">
        <ng-template pTemplate="container">
          <div class="flex flex-row align-items-center gap-3 w-full">
            <button
              type="button"
              class="text-xl font-bold cursor-pointer p-link"
              style="background: none; border: none;"
              aria-label="Απόρριψη ειδοποίησης"
              (click)="discardMessage(message)"
            >
              ×
            </button>
            <button
              type="button"
              class="text-wrap cursor-pointer p-link"
              style="background: none; border: none; text-align: left;"
              (click)="router.navigateByUrl('/calendar')"
            >
              {{ message.detail }}
            </button>
          </div>
        </ng-template>
      </p-message>
      } @empty {
        <div class="flex flex-column align-items-center justify-content-center gap-2 mt-5 text-center text-color-secondary">
          <i class="pi pi-bell-slash" style="font-size: 2.5rem; opacity: 0.4;"></i>
          <span>Καμία νέα ειδοποίηση</span>
        </div>
      }
    </div>
  </ng-template>
</p-drawer>
